export default __webpack_public_path__ + "static/media/radio_on.81ed57db.svg";